import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import { getVideoPlatform, safeURL } from "../../../../utils/string-helpers";
import { VideoLoading } from "../../../athlete-portal/profile/components/VideoCenterWatch";

const WeekVideo = ({ video, cycleVideo, locals }) => {
  const { t } = useTranslation("coaching-portal");
  const webAppTheme = locals.activeUser.webAppTheme || "dark";
  const [loading, setLoading] = useState(true);
  const [videoHTML, setVideoHTML] = useState(null);
  const [error, setError] = useState(false);
  const [videoId, setVideoId] = useState(null);

  const videoPlatform = getVideoPlatform(video);

  useEffect(() => {
    const fetchOembed = async () => {
      try {
        const { oembed } = await import("@loomhq/loom-embed");
        const res = await oembed(video);
        setVideoHTML(res.html);
      } catch (err) {
        console.error("Error fetching oEmbed:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (video && videoPlatform === "loom") {
      fetchOembed(); // only Loom needs oEmbed, YouTube is manual iframe
    } else if (video) {
      const parsedUrl = new URL(safeURL(video));
      const videoId =
        parsedUrl.hostname === "youtu.be"
          ? parsedUrl.pathname.slice(1)
          : parsedUrl.searchParams.get("v");
      setVideoId(videoId);
      setLoading(false);
    }
  }, [video, videoPlatform]);

  return (
    <Modal
      width="700px"
      className="watch-loom-modal"
      title={cycleVideo ? t("teams.weekVideo.teamIntroVideo") : t("teams.weekVideo.weekVideo")}
      toClear={["video", "cycleVideo"]}
    >
      <div className="video-container">
        {!loading ? (
          <div
            className={`body mt-4 py-4 ${
              videoPlatform === "youtube" ? "flex" : ""
            }`}
          >
            {error ? (
              <p className="font-bold text-center">{t("teams.weekVideo.errorLoadingVideo")}</p>
            ) : videoPlatform === "youtube" ? (
              <iframe
                width="560"
                height="315"
                src={`https://www.youtube.com/embed/${videoId}`}
                title={t("teams.weekVideo.youtubePlayerTitle")}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="m-auto"
              />
            ) : videoPlatform === "loom" && videoHTML ? (
              <div dangerouslySetInnerHTML={{ __html: videoHTML }}></div>
            ) : (
              <p className="font-bold text-center">{t("teams.weekVideo.invalidVideoLink")}</p>
            )}
          </div>
        ) : (
          <VideoLoading webAppTheme={webAppTheme} />
        )}
      </div>
    </Modal>
  );
};

export default WeekVideo;
